import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryRemoveFromFolderConfirm = props => (
	<Confirm
		btOne={localize('global_cancel')}
		btTwo={localize('my_library_remove_from_folder_button')}
		alertTitle={localize('my_library_remove_from_folder_title')}
		alertMessage={localize('my_library_remove_from_folder_message')}
		actionButtonType={1}
		actionOne={props.actions.cancelRemoveLesson}
		actionTwo={() => {
			props.actions.removeLesson(props.lesson)
		}}
		closeAction={props.actions.cancelRemoveLesson}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		removeLesson: myLibraryActions.removeFromFolderConfirmed,
		cancelRemoveLesson: myLibraryActions.removeFromFolderCancelled,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryRemoveFromFolderConfirm)
